module.exports = __webpack_public_path__ + "img/logo2.fe820cb6.svg";